<div class="sync-overlay" [class.open]="showSyncPanel()" (click)="closed.emit()"></div>
<aside class="sync-panel" [class.open]="showSyncPanel()" (click)="$event.stopPropagation()">

  <!-- Header -->
  <div class="sp-header">
    <div class="sp-header-left">
      <div class="sp-logo">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>
      </div>
      <div>
        <h3 class="sp-title">{{ 'OFFLINE.SYNC_STATUS' | translate }}</h3>
        <div class="sp-subtitle">StockFlow Desktop</div>
      </div>
    </div>
    <button class="sp-close" (click)="closed.emit()">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
    </button>
  </div>

  <!-- Connection card -->
  <div class="sp-body">
    <div class="sp-card sp-card-status" [class.sp-card-online]="offlineState().online()" [class.sp-card-offline]="!offlineState().online()">
      <div class="sp-status-icon">
        @if (offlineState().online()) {
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12.55a11 11 0 0 1 14.08 0"/><path d="M1.42 9a16 16 0 0 1 21.16 0"/><path d="M8.53 16.11a6 6 0 0 1 6.95 0"/><line x1="12" y1="20" x2="12.01" y2="20"/></svg>
        } @else {
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="1" y1="1" x2="23" y2="23"/><path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55"/><path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39"/><path d="M10.71 5.05A16 16 0 0 1 22.56 9"/><path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88"/><path d="M8.53 16.11a6 6 0 0 1 6.95 0"/><line x1="12" y1="20" x2="12.01" y2="20"/></svg>
        }
      </div>
      <div class="sp-status-info">
        <div class="sp-status-label">{{ (offlineState().online() ? 'OFFLINE.ONLINE' : 'OFFLINE.OFFLINE') | translate }}</div>
        @if (offlineState().hydrationStatus() !== 'idle') {
          <div class="sp-status-sub" [class.sp-sub-yellow]="offlineState().hydrationStatus() === 'hydrating'"
               [class.sp-sub-green]="offlineState().hydrationStatus() === 'done'"
               [class.sp-sub-red]="offlineState().hydrationStatus() === 'error'">
            <span class="sp-sub-dot"></span>
            {{ 'OFFLINE.HYDRATION_LABEL_' + offlineState().hydrationStatus().toUpperCase() | translate }}
          </div>
        }
      </div>
      <div class="sp-status-pulse" [class.active]="offlineState().online()"></div>
    </div>

    <!-- Pending mutations -->
    <div class="sp-section">
      <div class="sp-section-head">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></svg>
        <span>{{ 'OFFLINE.PENDING_MUTATIONS' | translate }}</span>
        @if (pendingRequests().length > 0) {
          <span class="sp-count-badge sp-count-warn">{{ pendingRequests().length }}</span>
        }
      </div>
      @if (pendingRequests().length === 0) {
        <div class="sp-empty-state">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
          <span>{{ 'OFFLINE.NO_PENDING' | translate }}</span>
        </div>
      } @else {
        <div class="sp-pending-list">
          @for (req of pendingRequests(); track req.id) {
            <div class="sp-pending-item">
              <div class="sp-method" [class.sp-method-post]="req.method === 'POST'"
                   [class.sp-method-put]="req.method === 'PUT'"
                   [class.sp-method-delete]="req.method === 'DELETE'">{{ req.method }}</div>
              <div class="sp-pending-url">{{ req.url | slice:-50 }}</div>
              <div class="sp-pending-time">{{ req.createdAt | date:'HH:mm' }}</div>
            </div>
          }
        </div>
      }
    </div>

    <!-- Synchronized collections -->
    <div class="sp-section">
      <div class="sp-section-head">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></svg>
        <span>{{ 'OFFLINE.COLLECTIONS' | translate }}</span>
        @if (syncLogs().length > 0) {
          <span class="sp-count-badge">{{ syncLogs().length }}</span>
        }
      </div>
      @if (syncLogs().length === 0) {
        <div class="sp-empty-state">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          <span>{{ 'OFFLINE.NO_SYNC_YET' | translate }}</span>
        </div>
      } @else {
        <div class="sp-collection-grid">
          @for (log of syncLogs(); track log.tableName) {
            <div class="sp-col-card" [class.sp-col-ok]="log.status === 'SUCCESS'" [class.sp-col-fail]="log.status === 'FAILED'">
              <div class="sp-col-top">
                <div class="sp-col-indicator"></div>
                <div class="sp-col-name">{{ log.tableName }}</div>
              </div>
              <div class="sp-col-bottom">
                <div class="sp-col-records">
                  <span class="sp-col-num">{{ log.recordCount }}</span> {{ 'OFFLINE.RECORDS' | translate }}
                </div>
                <div class="sp-col-time">{{ log.syncedAt | date:'HH:mm' }}</div>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
</aside>
